export class ReportCreationRequest {
    public Type!: number;
    public StartDate!: Date;
    public EndDate!: Date;
}
